<div
  class="xi-modal__container"
  *transloco="let t; read: 'add-configuration-layer-dialog-component'"
>
  <h2 class="xi-modal__title text-center">{{ t('title') }}</h2>

  <div class="xi-modal__content add-configuration-layer__content">
    <div>
      <app-lex-input
        placeholder="{{ t('input-placeholder') }}"
        inputClass="full-width"
        suffixIcon="search"
        suffixAction="clear"
        (valueChange)="search$.next($event)"
      ></app-lex-input>
    </div>

    <ng-template
      #tConfigsToAdd
      let-header="header"
      let-icon="icon"
      let-templateDs="templateDs"
      let-discriminator="discriminator"
    >
      <mat-expansion-panel [disabled]="isDataSourceEmpty(templateDs)" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <xi-icon [icon]="icon" class="add-configuration-layer__template-header-icon"></xi-icon>
            {{ header }}
          </mat-panel-title>

          <mat-panel-description>
            @if (isDataSourceEmpty(templateDs)) {
              <span>{{ t('no-config-error') }}</span>
            }
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div>
          @for (category of templateDs | keyvalue: entryOrder; track category) {
            @for (source of category.value; track source) {
              <div class="add-configuration-layer__template-row">
                <mat-checkbox
                  [checked]="isTemplateSelected(discriminator, category.key, source)"
                  (change)="toggleTemplate(discriminator, category.key, source)"
                >
                  {{ source.name }}
                </mat-checkbox>
                @if (icon === 'single_layer') {
                  <app-configuration-pill [templateType]="category.key"></app-configuration-pill>
                }
              </div>
            }
          }
        </div>
      </mat-expansion-panel>
    </ng-template>

    <div class="add-configuration-layer__configuration-list-header">
      {{ t('select-to-add') }}
    </div>

    <div class="add-configuration-layer__configuration-list">
      <ng-container
        *ngTemplateOutlet="
          tConfigsToAdd;
          context: {
            header: 'Standard Configurations',
            icon: 'single_layer',
            templateDs: filteredData.standardConfigs,
            discriminator: 'standardConfigs',
          }
        "
      ></ng-container>

      <ng-container
        *ngTemplateOutlet="
          tConfigsToAdd;
          context: {
            header: 'Layered Configurations',
            icon: 'multiple_layer',
            templateDs: filteredData.layeredConfigs,
            discriminator: 'layeredConfigs',
          }
        "
      ></ng-container>
    </div>
  </div>

  <div class="xi-modal__actions">
    <xi-default-button
      type="button"
      text="{{ t('cancel') }}"
      fill="text"
      (onClick)="cancel()"
    ></xi-default-button>

    <xi-default-button
      text="{{ t('add') }}"
      [disabled]="isSelectionEmpty()"
      (onClick)="add()"
    ></xi-default-button>
  </div>
</div>
